<div class='container d-flex'>
  <div class='col w-60 justify-content-center'>

    <div class="card card-primary" style='margin-top: 25px'>
      <div class='card-header'>
        <h5 class="card-title">Logout</h5>
      </div>

      <div class="card-body">
        <div class='col'>
          
          <div class='row'>
            <div class='col'>
              <p class='text-info text-center'>
                Sie haben sich erfolgreich ausgeloggt.
              </p>
            </div>
          </div>

          <div class='row'>
            <div class='col text-center'>
              <button class='btn btn-primary' routerLink="/login" title="Zum Login">
                <i class="fas fa-sign-in-alt"></i>
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</div>